// extracted by mini-css-extract-plugin
export var inputTwoCol = "lead-form-module--input-two-col--2KKnn";
export var leadForm = "lead-form-module--lead-form--10Ptp";
export var thankyouPage = "lead-form-module--thankyou-page--2AqlY";
export var dotFlashing = "lead-form-module--dot-flashing--XHNhS";
export var dots = "lead-form-module--dots--3_9XQ";